var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAgenda({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.556 14.054h14.548c.13 0 .256-.046.356-.13.14-.118 3.327-2.883 3.521-8.852H3.357C3.164 10.49.23 13.037.198 13.062a.565.565 0 00-.164.623c.08.22.288.369.522.369M18.443 1.703H15.66v-.561a.554.554 0 00-.557-.562.554.554 0 00-.556.562v.561h-2.821v-.561A.554.554 0 0011.17.58a.554.554 0 00-.558.562v.561H7.83v-.561A.554.554 0 007.273.58a.554.554 0 00-.557.562v.561H3.933a.554.554 0 00-.557.562v1.684H19V2.265a.554.554 0 00-.557-.562"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.175 14.785a1.668 1.668 0 01-1.072.392H3.376v1.684c0 .31.25.562.557.562h14.51A.56.56 0 0019 16.86v-6.293c-1.074 2.656-2.571 4.002-2.825 4.217"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgenda);
export default __webpack_public_path__ + "static/media/icon_agenda.7e60f29c93df93cb589398fbee3c575e.svg";
export { ForwardRef as ReactComponent };